var CurrencyControl = function () {
    const currenciesList = document.querySelector('.currencies ul');
    const defaultCurrency = document.querySelector('[data-currency-default]');

    const handle = function () {
        currenciesList.addEventListener('click', function (event) {
            const targetCurrency = event.target.closest('[data-currency-id]');
            if (targetCurrency) {
                event.preventDefault();
                currencyAjax(targetCurrency.getAttribute('data-currency-id'));
            }
        });
    };

    const currencyAjax = function (id) {
        if (!id) {
            return;
        }

        $.ajax({
            url: apiUrl + '/GetCurrency/' + id,
            type: 'GET',
            dataType: 'json',
            async: false,
            success: function (xhr) {
                updateCurrencyDisplay(xhr);
                updateLocalStorageAndActiveClass(xhr.id);
            },
            error: function (error) {
                console.error('Currency error:', error);
            }
        });
    };

    const updateCurrencyDisplay = function (xhr) {
        SetCurrency(xhr);

        defaultCurrency.setAttribute('data-currency-id', xhr.id);
        const symbolElement = defaultCurrency.querySelector('.symbol');
        const nameElement = defaultCurrency.querySelector('.name');
        
        if (symbolElement && nameElement) {
            symbolElement.innerText = xhr.symbol;
            nameElement.innerText = xhr.name;
        }
    };

    const updateLocalStorageAndActiveClass = function (currencyId) {
        localStorage.setItem('currency', currencyId);
        document.querySelectorAll('.currencies ul li.active').forEach(function (item) {
            item.classList.remove('active');
        });
        const currencyElement = currenciesList.querySelector('[data-currency-id="' + currencyId + '"]');
        if (currencyElement) {
            currencyElement.classList.add('active');
        }
    };

    return {
        init: function () {
            handle();

            const currencyLocalId = localStorage.getItem('currency') ?? currencyId;
            if (currencyData?.id == currencyLocalId) {
                SetCurrency(currencyData);
            } else {
                currencyAjax(currencyLocalId);
            }
        },
    };
}();

$(function () {
    CurrencyControl.init();
});

export function SetCurrency(xhr) {
    currencyFormat = wNumb({
        decimals: 2,
        thousand: xhr.thousands_separator,
        mark: xhr.decimal_mark,
        prefix: xhr.symbol,
    });
}
